import { combineReducers } from "redux";
import { RouterState } from "redux-first-history";
import { routerReducer } from "redux/HistoryContext";
import { LoginUser } from "models/LoginUser";
import { FuelStop } from "models/FuelStop";
import { FuelType } from "models/FuelType";
import { Machine } from "models/Machine";
import { MachineDefect } from "models/MachineDefect";
import { MachineHistory } from "models/MachineHistory";
import { MachineMaintenance } from "models/MachineMaintenance";
import { MachinePart } from "models/MachinePart";
import { MachineType } from "models/MachineType";
import { Manufacturer } from "models/Manufacturer";
import { ManufacturerType } from "models/ManufacturerType";
import { Maintenance } from "models/Maintenance";
import { Translations } from "models/Translations";
import { UiMessage } from "models/UiMessageModel";
import { UserRole } from "models/UserRole";
import { Unit } from "models/Unit";
import { UnitUsageType } from "models/UnitUsageType";
import { User } from "models/User";
import { CurrentSubscription, SubscriptionPlan } from "models/SubscriptionPlan";
import { Tenant } from "models/Tenant";
import { UserTask } from "models/UserTask";

import { fuelStopsReducer } from "redux/reducers/machines/FuelStopReducer";
import { fuelTypesReducer } from "redux/reducers/settings/FuelTypeReducer";
import { loginUserReducer } from "redux/reducers/LoginUserReducer";
import { machinesReducer } from "redux/reducers/settings/MachineReducer";
import { machineDefectsReducer } from "redux/reducers/machines/MachineDefectReducer";
import { machineHistoriesReducer } from "redux/reducers/machines/MachineHistoryReducer";
import { machineMaintenancesReducer } from "redux/reducers/settings/MachineMaintenanceReducer";
import { machinePartsReducer } from "redux/reducers/settings/MachinePartReducer";
import { machineTypesReducer } from "redux/reducers/settings/MachineTypeReducer";
import { manufacturersReducer } from "redux/reducers/settings/ManufacturerReducer";
import { manufacturerTypesReducer } from "redux/reducers/settings/ManufacturerTypeReducer";
import { maintenancesReducer } from "redux/reducers/settings/MaintenanceReducer";
import { mobileNavMenuReducer } from "redux/reducers/MobileNavMenuReducer";
import { modalDataReducer } from "redux/reducers/ModalReducer";
import { navMenuReducer } from "redux/reducers/NavMenuReducer";
import { processingRequestReducer } from "redux/reducers/ProcessingRequestReducer";
import { roleReducer } from "redux/reducers/RoleReducer"
import { translationsReducer } from "redux/reducers/TranslationsReducer";
import { uiMessageReducer } from "redux/reducers/UiMessageReducer";
import { unitsReducer } from "redux/reducers/settings/UnitReducer";
import { unitUsageTypesReducer } from "redux/reducers/settings/UnitUsageTypeReducer";
import { userReducer } from "redux/reducers/settings/UserReducer";
import { currentSubscriptionReducer, subscriptionPlansReducer } from "redux/reducers/settings/SubscriptionReducer";
import { currentTenantReducer, tenantsReducer } from "redux/reducers/settings/TenantReducer";
import { userTasksReducer } from "redux/reducers/UserTaskReducer";



export interface RootState {
  router: RouterState;
  machines: Machine[];
  fuelStops: FuelStop[];
  fuelTypes: FuelType[];
  machineDefects: MachineDefect[];
  machineHistories: MachineHistory[];
  machineMaintenances: MachineMaintenance[];
  machineParts: MachinePart[];
  machineTypes: MachineType[];
  manufacturers: Manufacturer[];
  manufacturerTypes: ManufacturerType[];
  maintenances: Maintenance[];
  loginUser: LoginUser;
  roles: UserRole[];
  units: Unit[];
  unitUsageTypes: UnitUsageType[];
  users: User[];
  userTasks: UserTask[];
  currentSubscription: CurrentSubscription | null;
  subscriptionPlans: SubscriptionPlan[];
  tenants: Tenant[];
  currentTenant: Tenant | null;
  uiMessages: UiMessage[];
  translations: Translations;
  navMenuToggle: boolean;
  processingRequest: boolean;
}

export const rootReducer = combineReducers({
  router: routerReducer,
  machines: machinesReducer,
  machineDefects: machineDefectsReducer,
  machineHistories: machineHistoriesReducer,
  machineMaintenances: machineMaintenancesReducer,
  machineParts: machinePartsReducer,
  machineTypes: machineTypesReducer,
  fuelStops: fuelStopsReducer,
  fuelTypes: fuelTypesReducer,
  manufacturers: manufacturersReducer,
  manufacturerTypes: manufacturerTypesReducer,
  maintenances: maintenancesReducer,
  modalData: modalDataReducer,
  loginUser: loginUserReducer,
  roles: roleReducer,
  units: unitsReducer,
  unitUsageTypes: unitUsageTypesReducer,
  users: userReducer,
  userTasks: userTasksReducer,
  currentSubscription: currentSubscriptionReducer,
  subscriptionPlans: subscriptionPlansReducer,
  tenants: tenantsReducer,
  currentTenant: currentTenantReducer,
  uiMessages: uiMessageReducer,
  translations: translationsReducer,
  navMenuToggle: navMenuReducer,
  mobileNavMenuToggle: mobileNavMenuReducer,
  processingRequest: processingRequestReducer
});